import React, { useState } from 'react';
import { FormLabel, FormErrorMessage, FormControl } from '@chakra-ui/react';
import { Controller, FieldValues } from 'react-hook-form';
import { Transfer as TransferAntd } from 'antd';
import type { TransferDirection } from 'antd/es/transfer';
import { TransferProps } from 'types';

const Transfer = <T extends FieldValues>({
  name,
  control,
  label,
  dataSource,
  rules,
  error,
  onChange
}: TransferProps<T>) => {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [localError, setLocalError] = useState<string | null>(null);

  const transformedData = dataSource.map(item => ({
    ...item,
    title: item.text,
    key: item.code,
  }));

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      rules={{
        ...rules,
        validate: (value) => {
          if (!value || value.length === 0) {
            return 'Por favor, selecione pelo menos um item';
          }
          return true;
        }
      }}
      render={({ onChange: changeEvent, value }) => (
        <FormControl isInvalid={!!error || !!localError} mb="20px">
          <FormLabel color="brand.primary">{label}</FormLabel>
          <TransferAntd
            className="no-header-transfer" // Added custom class to hide header space
            dataSource={transformedData}
            titles={[]}
            showSelectAll={false}
            selectAllLabels={[
                ({ selectedCount, totalCount }) => (
                  ""
                ),
                 ({ selectedCount, totalCount }) => (
                  ""
                )
              ]}
            targetKeys={value || []}
            selectedKeys={selectedKeys}
            onChange={(nextTargetKeys: string[], direction: TransferDirection) => {
              if (onChange) {
                onChange(nextTargetKeys, direction, selectedKeys, name);
              }
              changeEvent(nextTargetKeys);
              setLocalError(null);
            }}
            onSelectChange={(sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
              
              setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
            }}
            onScroll={(direction: TransferDirection, e: React.SyntheticEvent<HTMLUListElement>) => {}}
            render={item => item.title}
          />
          {(error || localError) && (
            <FormErrorMessage pl={['0', '0']}>
              {error?.message || localError}
            </FormErrorMessage>
          )}
        </FormControl>
      )}
    />
  );
};

export default Transfer;
